import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { currentOrganization, currentUser } from './selectors'
import { isRole, isRoleAtLeast, USER } from './utils/permissions'
import { DEFAULT_TIME_ZONE } from 'civic-champs-shared/utils/format'

export const useCurrentUser = () => useSelector(currentUser)
export const useCurrentOrg = () => useSelector(currentOrganization)

export const useTimeZone = () => {
  const organization = useCurrentOrg()
  return useMemo(() => organization.timeZone || DEFAULT_TIME_ZONE, [organization.timeZone])
}

export const useHasRole = role => {
  let user = useCurrentUser()

  if (!user) user = {}
  if (!user.permissions) {
    user.permissions = {
      role: USER,
      managedOrganization: null,
    }
  }

  return useMemo(() => {
    if (!isRole(role)) {
      console.error(`Unrecognized role '${role}', hiding components to prevent access`)
      return null
    }

    return isRoleAtLeast(user.permissions, role)
  }, [user, role])
}
